<div class="mt-4 p-4 border-radius">
	<div class="row">
		<div class="col-sm-12 col-md-12 d-flex justify-content-between">
			<h4>
				{{widgetConfig.title | translate}}
				<app-help-tooltip *ngIf="widgetConfig.tooltip" [field]="widgetConfig.tooltip"></app-help-tooltip>
			</h4>

			<div *ngIf="locations.length">
				<fa-icon class="main-blue pointer" [icon]="['fas', 'map-marker-alt']" [size]="['2x']" [title]="'device_management.view_location' |translate"
					(click)="outOfGeofenceLocationDevicesModal.show(); isShownMap=true"
				></fa-icon>
			</div>
		</div>
	</div>

	<sct-custom-table
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
</div>

<app-modal #outOfGeofenceLocationDevicesModal title="{{'g.locations' | translate}}" size="lg" [hasConfirmButton]="false">
	<app-mapbox-search *ngIf="locations.length && isShownMap"
		class="border-radius main-blue-border"
		[latitude]="siteService.defaultMapLocation.latitude"
		[longitude]="siteService.defaultMapLocation.longitude"
		zoom="3.5"
		dotsType="mix"
		[dots]="locations"
	></app-mapbox-search>
</app-modal>
